import { render, staticRenderFns } from "./ActivityOrganization.vue?vue&type=template&id=683999bc&scoped=true&"
import script from "./ActivityOrganization.vue?vue&type=script&lang=js&"
export * from "./ActivityOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683999bc",
  null
  
)

export default component.exports